import { render, staticRenderFns } from "./materialComponent.vue?vue&type=template&id=587a6c61&scoped=true&"
import script from "./materialComponent.vue?vue&type=script&lang=js&"
export * from "./materialComponent.vue?vue&type=script&lang=js&"
import style0 from "./materialComponent.vue?vue&type=style&index=0&id=587a6c61&scoped=true&lang=css&"
import style1 from "./materialComponent.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587a6c61",
  null
  
)

export default component.exports